import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Button
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ApiService from "../../Api/ApiController";
import Swal from "sweetalert2";
import Search from "../../components/Search";

const UserList = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({});
  const [page,setpage] = useState(1);
  const [search,setsearch] =useState('');
  const handlePageChange=(page)=>{
    setpage(page)
  }
  const getuserlist = () => {
    ApiService.userlist({page,search})
      .then((response) => {
        if (response.data.status === true) {
          setUsers(response.data.data.data);
          setPagination(response.data.data.paginator);
        } else {
          setUsers([]);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    getuserlist();
  }, [page,search]);

  const handleuserview = (userId) => {
    navigate(`/userview/${userId}`);
  };

  const handleDelete = (userId)=>{
    console.log(userId)
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to delete this user?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    }).then((result)=>{
      if(result.isConfirmed){
        ApiService.deleteUser(userId).then((response)=>{
          if(response.data.status === true){
            Swal.fire({
              icon:'success',
              text: response.data.message
            });
            getuserlist();
          }else{
            Swal.fire({
              icon:'error',
              text: response.data.message
            })
          }
      }).catch((error)=>{
        console.log(error);
        Swal.fire({
          icon:'error',
          text: error.response.data.message
        })
      });
      }
    })
   
  }
  const handleSearch = (searchValue)=>{
    setsearch(searchValue);
  }

  return (
    <Box sx={{ padding: "16px" }}>
      <Typography variant="h4" gutterBottom>
        User List
      </Typography>
           <Box>
           <Search onSearch={handleSearch} />
           </Box>
      {/* Add a responsive wrapper */}
      <Box
        sx={{
        
          borderRadius: 1,
          boxShadow: 1,
        }}
      >
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="responsive table">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Mobile Number</TableCell>
                <TableCell>Gender</TableCell>
                <TableCell>Annual Salary</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user, index) => (
                <TableRow key={user._id}>
                 <TableCell data-label="ID">{index + 1}</TableCell>
<TableCell data-label="Name">{user.name || "--"}</TableCell>
<TableCell data-label="Email">{user.email || "--"}</TableCell>
<TableCell data-label="Mobile Number">{"+91" + user.mobile_number}</TableCell>
<TableCell data-label="Gender">{user.gender || "--"}</TableCell>
<TableCell data-label="Annual Salary">{user.yearly_income || "--"}</TableCell>
<TableCell data-label="Action" sx={{    display: 'flex', gap: '10px'}}>
  <Button variant="contained" onClick={() => handleuserview(user._id)}>
    <i className="bx bx-detail"></i>
  </Button>
  <Button variant="contained" onClick={() => handleDelete(user._id)}>
    <i className="bx bx-trash"></i>
  </Button>
</TableCell>

                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div className="pagination_latestTrend">
      {pagination.totalPages > 1 && (
                        <>
                         
                              <Button disabled={!pagination.hasPrevPage}  onClick={() => handlePageChange(page - 1)}><i className='bx bx-left-arrow-alt' ></i></Button>
                       
                            <span>Page {page} of {pagination.totalPages}</span>
                           
                              <Button  disabled={!pagination.hasNextPage}  onClick={() => handlePageChange(page + 1)}><i className='bx bx-right-arrow-alt'></i></Button>
                        
                        </>
                    )}
                    </div>
      </Box>
    </Box>
  );
};

export default UserList;
